import React from 'react'

import './HeaderText.css'
export default function HeaderText({ children }) {
  return <h3 className="HeaderText">{children}</h3>
}
